import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Grid, Button, Paper, MuiThemeProvider } from '@material-ui/core';
import { makeStyles, alpha } from '@material-ui/core/styles';
import theme from '../../theme';

// One dialog is open at a time (react-confirm-alert), so a fixed id is enough.
const MESSAGE_ID = 'confirm-dialog-message';

// The dialog has its own MuiThemeProvider, so the styles read the imported
// theme instead of the caller's provider.
const useDialogStyles = makeStyles({
  // Explicit hover tint for "No" (MUI's secondary hover would be green).
  no: {
    '&:hover': { backgroundColor: alpha(theme.palette.error.dark, 0.04) },
  },
  // Visible 3:1 focus indicator, also for programmatic focus.
  ring: {
    '&.Mui-focusVisible, &:focus-visible': {
      outline: `3px solid ${theme.palette.primary.main}`,
      outlineOffset: 2,
    },
  },
});

// Shared Yes/No confirmation shown through react-confirm-alert. The initial
// focus goes to "No", the safe action. Returning the focus to the opener is
// up to the caller (confirmAlert's afterClose).
export default ({ onClose, message, onConfirmClick }) => {
  const { t } = useTranslation();
  const classes = useDialogStyles();

  return (
    <MuiThemeProvider theme={theme}>
      <Paper
        style={{ padding: '20px' }}
        role="alertdialog"
        aria-modal="true"
        aria-labelledby={MESSAGE_ID}
      >
        <Grid
          container
          spacing={3}
          justify="center"
          direction="row"
          alignItems="center"
          style={{ padding: '20px 0' }}
        >
          <Grid item xs={12}>
            <Typography id={MESSAGE_ID} variant="h6" component="p" align="center">
              {message}
            </Typography>
            <hr />
          </Grid>
          <Grid xs={6} item style={{ textAlign: 'center' }}>
            <Button
              type="button"
              className={classes.ring}
              style={{ textTransform: 'lowercase', minHeight: 44 }}
              variant="contained"
              color="primary"
              onClick={() => {
                onConfirmClick();
                onClose();
              }}
            >
              {t('Yes')}
            </Button>
          </Grid>
          <Grid xs={6} item style={{ textAlign: 'center' }}>
            <Button
              type="button"
              autoFocus
              className={`${classes.ring} ${classes.no}`}
              variant="outlined"
              style={{
                borderColor: theme.palette.error.dark,
                color: theme.palette.error.dark,
                textTransform: 'lowercase',
                minHeight: 44,
              }}
              onClick={onClose}
            >
              {t('No')}
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </MuiThemeProvider>
  );
};
